import React from 'react';
import { Icon } from './Icon.js';
export const IconFollowObjDownRightFill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M7.75,2.49c-.414,0-.75,.336-.75,.75v2.7L3.28,2.22c-.293-.293-.768-.293-1.061,0s-.293,.768,0,1.061l3.72,3.72H3.24c-.414,0-.75,.336-.75,.75s.336,.75,.75,.75H7.75c.414,0,.75-.336,.75-.75V3.24c0-.414-.336-.75-.75-.75Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "9", y: "9", width: "7", height: "7", rx: "1.75", ry: "1.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconFollowObjDownRightFill18.js.map